import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Vehicle {
  id: number;
  assetCode: string;
  name: string;
  category: string;
  status: string;
  location: string;
  details: string;
  dailyRate: number;
  weeklyRate: number;
  monthlyRate: number;
  imageUrl?: string;
}

export interface Faq {
  id: number;
  question: string;
  answer: string;
  module: string;
  sortOrder: number;
}

export interface ContactRequest {
  fullName: string;
  email: string;
  phone?: string;
  company?: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class ApiService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  // Vehicles
  getVehicles(status?: string): Observable<Vehicle[]> {
    const params = status ? `?status=${status}` : '';
    return this.http.get<Vehicle[]>(`${this.baseUrl}/vehicles${params}`);
  }

  getVehicle(id: number): Observable<Vehicle> {
    return this.http.get<Vehicle>(`${this.baseUrl}/vehicles/${id}`);
  }

  // FAQs
  getFaqs(module?: string): Observable<Faq[]> {
    const params = module ? `?module=${module}` : '';
    return this.http.get<Faq[]>(`${this.baseUrl}/faqs${params}`);
  }

  // Contact
  submitContact(request: ContactRequest): Observable<ContactRequest> {
    return this.http.post<ContactRequest>(`${this.baseUrl}/contact`, request);
  }

  // Registration
  submitRegistration(registration: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/register`, registration);
  }
}
